import React from 'react';
import {
  Pagination, Input, Select,
} from '../../../components/base';

export default class Elearningmurid extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="fund-request">
        <div className="fund-request__content">
          <Select
            // value={data.teacher_id}
            placeholder="Mata Pelajaran"
            // data={Pengajar}
            // data-input-array
            // arrayPosition={idx}
            // data-array-position={idx}
            data-field-name="pelajaran"
            name="id_matpel"
          />
          <div className="finance">
            <div className="finance__list">
              <button>
                <img src="" alt="No Image" />
                <h3>Soal 1</h3>
              </button>
              <Input
                type="text"
                name="status"
                label="Status"
                placeholder="Done"
              />
            </div>
            <div className="finance__list">
              <button>
                <img src="" alt="No Image" />
                <h3>Soal 2</h3>
              </button>
              <Input
                type="text"
                name="status"
                label="Status"
                placeholder="Deadline: HH:MM:SS"
              />
            </div>
          </div>
        </div>
        <div className="user-management__table-footer">
          {/* <p className="user-management__page-info">
              {`${language.translate.COMPONENT__CONTENT_TABLE__PAGE} ${list.currentPage} ${language.translate.COMPONENT__CONTENT_TABLE__OF} ${list.totalPage}`}
            </p> */}
          <Pagination
            totalPage={3}
            currentPage={1}
          />
        </div>
      </div>
    );
  }
}
